import { lazy, Suspense } from 'react'
import { CircularProgressContinuousSized } from '../loaders/CircularProgressContinuous'
import { PaxtonHighlightArea } from './schema/paxton-highlight-area'

// Lazy load ReactPdfWorkerWrapper
const PdfWorkerWrapper = lazy(() => import('./components/PdfWorkerWrapper'))

type RenderReactPdfViewerProps = {
  highlightAreas: PaxtonHighlightArea[]
  pdfFile: File
  startingPage?: number
  excerpt?: string
  /** Starting zoom as a scale factor (1 is 100%). Defaults to fitting the page width. */
  defaultScale?: number
}

export default function RenderReactPdfViewer(props: RenderReactPdfViewerProps): JSX.Element {
  const { highlightAreas, pdfFile, startingPage, excerpt, defaultScale } = props

  return (
    <Suspense
      fallback={
        <div className={'flex items-center gap-x-1'}>
          Loading PDF libraries... <CircularProgressContinuousSized size={12} thickness={7} />
        </div>
      }
    >
      <div className="flex flex-col h-full w-full mb-4">
        <PdfWorkerWrapper pdfFile={pdfFile} highlightAreas={highlightAreas} startingPage={startingPage} excerpt={excerpt} defaultScale={defaultScale} />
      </div>
    </Suspense>
  )
}
